import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    '&:has(.MuiStepLabel-vertical)': {
      position: 'relative',
    },
    '&:has(.MuiStepLabel-vertical):not(.apollo-theme-box):before': {
      content: '""',
      display: 'block',
      width: 2,
      top: 36,
      left: 16,
      position: 'absolute',
      height: 'calc(100% - calc(28px))',
      backgroundColor: idsTokens.stepper.default.color.incomplete.path.enabled,
    },
    '&.MuiStep-root:last-child::before': { display: 'none' },
    '&.MuiStep-root.Mui-completed:not(:has(.Mui-active))::before': {
      backgroundColor: idsTokens.stepper.default.color.completed.path.enabled,
    },
    '& .Mui-active': {
      '& .apollo-theme-dot': {
        stroke: idsTokens.stepper.default.color.inProgress.box.enabled,
        fill: idsTokens.stepper.default.color.inProgress.icon.enabled,
        transition: 'none',
      },
    },
    '&.apollo-theme-dot': {
      '& .Mui-active, & .Mui-completed': {
        '&.MuiStepConnector-horizontal > .MuiStepConnector-line': {
          borderColor: idsTokens.stepper.default.color.incomplete.path.enabled,
        },
      },
      '&.Mui-completed + div .Mui-active, &.Mui-completed + .Mui-completed': {
        '&.MuiStepConnector-horizontal > .MuiStepConnector-line': {
          borderColor: idsTokens.stepper.default.color.completed.path.enabled,
        },
      },
    },
    '&.apollo-theme-disabled': {
      pointerEvents: 'none',
      cursor: 'auto',
      '&.Mui-completed': {
        color: idsTokens.stepper.default.color.completed.text.disabled,
      },
    },
    '& .Mui-completed.MuiStepLabel-iconContainer': {
      position: 'relative',
      zIndex: 2,
    },
    '&:hover': {
      '& .MuiStepLabel-iconContainer': {
        '& svg': {
          color: idsTokens.stepper.default.color.incomplete.icon.hover,
          '&.apollo-theme-dot': {
            stroke: idsTokens.stepper.default.color.incomplete.icon.hover,
          },
        },
      },
      '& .MuiStepLabel-label': {
        color: idsTokens.stepper.default.color.incomplete.text.hover,
      },
      '& .Mui-active, & .Mui-completed': {
        '&.MuiStepLabel-label': {
          color: idsTokens.stepper.default.color.completed.text.hover,
        },
      },
      '& .Mui-active': {
        '&.MuiStepLabel-iconContainer': {
          '& svg': {
            color: idsTokens.stepper.default.color.inProgress.box.hover,
            '& text, &.apollo-theme-border': {
              fill: idsTokens.stepper.default.color.inProgress.icon.hover,
            },
            '&.apollo-theme-dot': {
              stroke: idsTokens.functional.color.surface.container.solid['brand-inverse'].hover,
              fill: idsTokens.stepper.default.color.inProgress.icon.hover,
            },
          },
        },
      },
      '& .Mui-completed': {
        '&.MuiStepLabel-iconContainer': {
          '& svg': {
            color: idsTokens.stepper.default.color.completed.icon.hover,
            '&.apollo-theme-dot': {
              stroke: idsTokens.stepper.default.color.completed.icon.hover,
            },
          },
        },
      },
    },
    '&:active': {
      '& .MuiStepLabel-iconContainer': {
        '& svg': {
          color: idsTokens.stepper.default.color.incomplete.icon.pressed,
          '& text': {
            fill: idsTokens.functional.color.surface.container.solid.default.enabled,
          },
          '&.apollo-theme-dot': {
            stroke: idsTokens.stepper.default.color.incomplete.icon.pressed,
          },
        },
      },
      '& .MuiStepLabel-label': {
        color: idsTokens.stepper.default.color.incomplete.text.pressed,
      },
      '& .Mui-active, & .Mui-completed': {
        '&.MuiStepLabel-iconContainer': {
          '& svg': {
            '&.apollo-theme-dot': {
              stroke: idsTokens.functional.color.surface.container.solid['brand-inverse'].pressed,
              fill: idsTokens.stepper.default.color.completed.icon.pressed,
            },
          },
        },
        '&.MuiStepLabel-label': {
          color: idsTokens.stepper.default.color.completed.text.pressed,
        },
      },
      '& .Mui-active': {
        '&.MuiStepLabel-iconContainer': {
          '& svg': {
            color: idsTokens.stepper.default.color.completed.box.pressed,
            '& text, &.apollo-theme-border': {
              fill: idsTokens.stepper.default.color.inProgress.icon.pressed,
            },
          },
        },
      },
      '& .Mui-completed': {
        '&.MuiStepLabel-iconContainer': {
          '& svg': {
            color: idsTokens.stepper.default.color.completed.icon.pressed,
            '& text': {
              fill: idsTokens.stepper.default.color.completed.icon.pressed,
            },
          },
        },
      },
    },
    '&.apollo-theme-box': {
      width: '100%',
      border: `1px solid ${idsTokens.stepper.default.color.boxBorder.enabled}`,
      marginBottom: idsTokens.stepper.default.spacing.box.gap,
      padding: `${idsTokens.stepper.default.spacing.box.top} ${idsTokens.stepper.default.spacing.box.right} ${idsTokens.stepper.default.spacing.box.bottom} ${idsTokens.stepper.default.spacing.box.left}`,
      borderRadius: idsTokens.stepper.default.radius.container,
      display: 'flex',
      alignItems: 'center',
      minWidth: idsTokens.stepper.default.sizing.text.min.width,
      maxWidth: idsTokens.stepper.default.sizing.text.max.width,
      minHeight: idsTokens.stepper.default.sizing.text.min.height,
      maxHeight: idsTokens.stepper.default.sizing.text.max.width,
      boxSizing: 'border-box',
      background: idsTokens.functional.color.surface.container.solid.default.enabled,
      '& .MuiStepLabel-root.MuiStepLabel-horizontal': {
        alignItems: 'unset',
      },
      '&.apollo-theme-disabled': {
        background: idsTokens.stepper.default.color.incomplete.box.disabled,
        borderColor: idsTokens.stepper.default.color.boxBorder.disabled,
      },
      '&:has(.Mui-active)': {
        background: idsTokens.stepper.default.color.incomplete.box.enabled,
        '&.apollo-theme-disabled': {
          background: idsTokens.stepper.default.color.completed.box.disabled,
        },
      },
      '&.Mui-completed': {
        background: idsTokens.stepper.default.color.completed.box.enabled,
      },
      '&:hover': {
        background: idsTokens.stepper.default.color.inProgress.box.hover,
        borderColor: idsTokens.stepper.default.color.boxBorder.hover,
      },
      '&:active': {
        background: idsTokens.stepper.default.color.inProgress.box.pressed,
        borderColor: idsTokens.stepper.default.color.boxBorder.pressed,
      },
    },
    '&:focus': {
      outline: `${idsTokens.functional.borderWidth.focus.default} solid ${idsTokens.functional.color.border.focus}`,
      outlineOffset: 1,
    },
  },
});
